export default __webpack_public_path__ + "static/media/About-Our-Story.30b44acb.png";